import React from "react";
import "../Styles/PrivacyPolicy.css"; // Import external CSS
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="privacy-container">
      <h3>Version 1 – September, 2024</h3>
        <h1>Privacy Policy</h1>
        <h2>SCOPE</h2>
        <p>
          This Privacy Policy applies to website, any online application,
          services, offerings provided by Ishya Foundation that refers to or
          links to the Privacy Policy (collectively, our “Services”). The
          Privacy Policy applies regardless of whether you use a computer,
          mobile phone, tablet, TV, or other device to access our Services.
        </p>
        <h2>INFORMATION WE COLLECT</h2>
        <p>
          We collect various types of information in connection with the
          Services, including: Information you provide directly to us;
          Information we collect about your use of our Services; and
          Information we obtain from third-party sources. We also use the
          information we collect in ways described to you at the point of
          collection, or otherwise with your consent.
        </p>

        <h2>USE AND SHARING OF INFORMATION</h2>
        <p>
          We use the information we collect (and may combine it with other
          information about you) to, among other things: Provide the Services
          you request; Understand the way you use the Services so that we can
          improve your experience; and Provide customized content and
          advertising. We also use the information we collect in ways described
          to you at the point of collection, or otherwise with your consent. We
          may share your information with: Business partners—trusted companies
          that may provide information about products and services you might
          like. Service providers—companies that provide services for or on
          behalf of the Ishya Foundation. Law enforcement—when we are required
          to do so or to protect Ishya Foundation and its users.
        </p>

        <h2>ISHYA FOUNDATION PRIVACY POLICY</h2>
        <p>
          Ishya Foundation and our affiliates (“Ishya,” “we,” “us,” “our”) know
          how important is it to maintain the privacy of our users, and we
          therefore are very cautious about how we collect, use, disclose,
          transfer and store your information. This Privacy Policy applies to
          the Services, however any additional consent will be obtained for
          certain data processing activities. Please note that the Privacy
          Policy applies to your usage of our Services. It also applies
          regardless of whether you use a computer, mobile phone, tablet, TV, or
          other device to access our Services. It is important that you read
          the Privacy Policy carefully because anytime you use our Services,
          you consent to the practices we describe in the Privacy Policy. If
          you do not agree to the practices described in the Privacy Policy,
          you should not use our Services. It also is important that you check
          back often for updates to the Privacy Policy. If we update the
          Privacy Policy, and we consider it to be material, we shall highlight
          the same by placing a note on relevant Services. By accessing or
          using our Services after we have placed such a notice, you consent
          to the new practice(s) identified in the update. You can check the
          “effective date” posted at the top to see when the Privacy Policy was
          last updated.
        </p>

        <h2>What information do we collect about you?</h2>
        <h3>Information you provide directly</h3>
        <p>
          Some Services enable you to give us information directly. For
          example: If any of our Services enable users to create accounts or
          profiles, we may ask you to provide certain information about
          yourself to set up the account or profile. For example, you can
          submit certain information about yourself, such as your name and
          email address, when you create a login account with us. Some of our
          Services enable you to communicate with other people. Those
          communications will be transmitted through and stored on our systems.
        </p>

        <h3>Information about your use of the Services</h3>
        <p>
          In addition to the information you provide, we may collect
          information about your use of our Services through software on your
          device and other means. For example, we may collect: Device
          information—such as your hardware model and other unique device
          identifiers, MAC address, IP address, operating system version, and
          settings of the device you use to access the Services. Log
          information-such as the time and duration of your use of the Service,
          search query terms you enter through the Services, and any
          information stored in cookies that we have set on your device.
          Location information—such as your device’s GPS signal or information
          about nearby WiFi access points and cell towers that may be
          transmitted to us when you use certain Services. Other information
          about your use of the Services, such as the apps you use, the
          websites you visit, and how you interact with content offered through
          a Service.
        </p>

        <h3>Information from third-party sources</h3>
        <p>
          We may receive information about you from publicly and commercially
          available sources (as permitted by law), which we may combine with
          other information we receive from or about you. We also may receive
          information about you from third-party social networking services
          when you choose to connect with those services. If you order a
          product or paid service online, the third-party sources managing
          online activities may ask for your name, contact information,
          shipping and billing address(es), and credit card information in order
          to process your order.
        </p>

        <h3>Other Information We Collect</h3>
        <p>
          We also may collect other information about you, your device, or your
          use of the Services in ways that we describe to you at the point of
          collection or otherwise with your consent. You can choose not to
          provide us with certain types of information (e.g., information we
          request during account registration), but doing so may affect your
          ability to use some Services.
        </p>

        <h2>How do we use your information?</h2>
        <p>
          We may use information we collect for the following purposes to:
          <br />
          a. register you or your device for a Service;
          <br />
          b. provide a Service or feature you request;
          <br />
          c. provide customised content and make recommendations based on your
          past activities on our Services;
          <br />
          d. for advertising, such as providing customised advertisements and
          sponsored content (including through our advertising service, AdHub,
          whose practices you can learn more about here) and sending you
          promotional communications;
          <br />
          e. for assessment and analysis of our market, customers, products,
          and services (including asking you for your opinions on our products
          and services and carrying out customer surveys);
          <br />
          f. understand the way people use our Services so that we can improve
          them and develop new products and services;
          <br />
          g. provide maintenance services for your device;
          <br />
          h. conduct free prize drawings, prize competitions or promotions, as
          permitted by law; and otherwise with your consent.
          <br />
          i. combine information we collect from you and use it for purposes
          consistent with this Privacy Policy.
        </p>

        <h2>To whom do we disclose your information?</h2>
        <p>
          We will not disclose your information to third parties for their own
          independent marketing or business purposes without your consent.
          However, we may disclose your information to the following entities:
          <br />
          Affiliates. Your information may be shared amongst our affiliates.
          <br />
          Business Partners. We also may share your information with trusted
          business partners for the purpose of providing Services to you.
          <br />
          Service Providers. We also may disclose your information to third
          parties that provide services for or on behalf of us, such as
          companies that run service centres, help us with billing or that send
          emails on our behalf. These entities are limited in their ability to
          use your information for purposes other than providing services for
          us.
          <br />
          Other Parties When Required by Law or as Necessary to Protect Our
          Services. There may be instances when we disclose your information
          to other parties to:
          <br />
          a. comply with the law or respond to compulsory legal process (such
          as a search warrant or other court order);
          <br />
          b. verify or enforce compliance with the policies governing our
          Services; and
          <br />
          c. protect the rights, property, or safety of Ishya Foundation, or
          any of our respective affiliates, business partners, or customers.
          <br />
          Other Parties With Your Consent or At Your Direction. In addition to
          the disclosures described in this Privacy Policy, we may share
          information about you with third parties when you consent to or
          request such sharing.
        </p>

        <h2>Your Choices</h2>
        <p>
          We offer a variety of choices about how we use your information. You
          can make choices about whether to receive promotional communications
          from us by following the unsubscribe instructions included in the
          communication. In addition, you can also generally make choices in
          your settings in your login account. And you may be able to make
          choices in specific Services or when we give you a just-in-time
          notice.
        </p>

        <h2>What do we do to keep your information secure?</h2>
        <p>
          We have put in place reasonable physical and technical measures to
          safeguard the information we collect in connection with the
          Services. However, please note that although we take reasonable steps
          to protect your information, no website, Internet transmission,
          computer system or wireless connection is completely secure.
        </p>

        <h2>Consent to International Transfer of Data</h2>
        <p>
          By using or participating in any Service and/or providing us with
          your information, you consent to the collection, transfer, storage
          and processing of your information outside of your country of
          residence, consistent with this Privacy Policy. Please note that the
          data protection and other laws of countries to which your information
          may be transferred might not be as comprehensive as those in your
          country.
        </p>

        <h2>Accessing Your Information</h2>
        <p>
          You may have the right to request details about the information we
          collect and to correct inaccuracies in that information. Any further
          statutory user rights remain unaffected. If permitted by law, we may
          charge you a small fee for providing you with this ability. We may
          decline to process requests that are unreasonably repetitive, require
          disproportionate technical effort, jeopardize the privacy of others,
          are extremely impractical, or for which access is not otherwise
          required by local law. If you would like to make a request to access
          your information, please contact our customer service department at
          http://_____________.
        </p>

        <h2>Data Retention</h2>
        <p>
          We take reasonable steps to ensure that we retain information about
          you only for so long as is necessary for the purpose for which it was
          collected, or as required under any contract or by applicable law.
        </p>

        <h2>Third-Party Links and Products on Our Services</h2>
        <p>
          Our Services may link to third-party websites and services that are
          outside our control. We are not responsible for the security or
          privacy of any information collected by websites or other services.
          You should exercise caution, and review the privacy statements
          applicable to the third-party websites and services you use. We also
          may make available to you certain products or services (e.g., apps
          available through app stores) developed by third parties. Ishya
          Foundation is not responsible in any manner whatsoever for these
          third-party products or services.
        </p>

        <h2>
          Third Parties that Provide Content, Advertising or Functionality on
          Our Services
        </h2>
        <p>
          Some of the content, advertising, and functionality on our Services
          may be provided by third parties that are not affiliated with us. For
          example:
          <br />
          a. Certain third parties may serve advertising or keep track of which
          advertisements users see, how often they see those advertisements,
          and what users do in response to them;
          <br />
          b. We enable you to share certain materials on the Services with
          others through social networking services such as Facebook, Twitter,
          Google +, and LinkedIn.
          <br />
          c. These third-parties may collect or receive certain information
          about your use of the Services, including through the use of cookies,
          beacons, and similar technologies, and this information may be
          collected over time and combined with information collected across
          different websites and online services. Some of these companies
          participate in industry-developed programs designed to provide
          consumers choices about whether to receive targeted advertising. If
          you connect with a social networking service, we may receive and
          store authentication information from that service to enable you to
          log in, as well as other information that you allow us to receive
          when you connect with these services. Also, please note that if you
          choose to connect with a social networking service on a device used
          by people in addition to you, those other users may be able to see
          information stored or displayed in connection with your account on
          the social networking service(s) with which you connect.
        </p>

        <h2>Cookies, Beacons and Similar Technologies</h2>
        <p>
          We, as well as certain third parties that provide content,
          advertising, or other functionality on our Services, may use cookies,
          beacons, and other technologies in certain areas of our Services.
        </p>

        <h3>Cookies</h3>
        <p>
          Cookies are small files that store information on your computer, TV,
          mobile phone or other device. They enable the entity that put the
          cookie on your device to recognise you across different websites,
          services, devices, and/or browsing sessions. Cookies serve many
          useful purposes. For example:
          <br />
          a. Cookies can remember your sign-in credentials so you don’t have to
          enter those credentials each time you log on to a service.
          <br />
          b. Cookies help us and third parties understand which parts of our
          Services are the most popular because they help us to see which pages
          and features visitors are accessing and how much time they are
          spending on the pages. By studying this kind of information, we are
          better able to adapt the Services and provide you with a better
          experience.
          <br />
          c. Cookies help us and third parties understand which ads you have
          seen so that you don’t receive the same ad each time you access a
          Service.
          <br />
          d. Cookies help us and third parties provide you with relevant
          content and advertising by collecting information about your use of
          our Services and other websites and apps. When you use a web browser
          to access the Services, you can configure your browser to accept all
          cookies, reject all cookies, or notify you when a cookie is sent.
          Each browser is different, so check the “Help” menu of your browser
          to learn how to change your cookie preferences. The operating system
          of your device may contain additional controls for cookies. Please
          note, however, that some Services may be designed to work using
          cookies and that disabling cookies may affect your ability to use
          those Services, or certain parts of them.
        </p>

        <h3>Other Local Storage</h3>
        <p>
          We, along with certain third parties, may use other kinds of local
          storage technologies, such as Local Shared Objects (also referred to
          as “Flash cookies”) and HTML5 local storage, in connection with our
          Services. These technologies are similar to the cookies discussed
          above in that they are stored on your device and can be used to
          store certain information about your activities and preferences.
          However, these technologies may make use of different parts of your
          device from standard cookies, and so you might not be able to control
          them using standard browser tools and settings. For information about
          disabling or deleting information contained in Flash cookies, please
          click here.
        </p>

        <h3>Beacons</h3>
        <p>
          We, along with certain third parties, also may use technologies
          called beacons (or “pixels”) that communicate information from your
          device to a server. Beacons can be embedded in online content,
          videos, and emails, and can allow a server to read certain types of
          information from your device, know when you have viewed particular
          content or a particular email message, determine the time and date on
          which you viewed the beacon, and the IP address of your device. We
          and certain third parties use beacons for a variety of purposes,
          including to analyse the use of our Services and (in conjunction
          with cookies) to provide content and ads that are more relevant to
          you. By accessing and using our Services, you consent to the storage
          of cookies, other local storage technologies, beacons and other
          information on your devices. You also consent to the access of such
          cookies, local storage technologies, beacons and information by us
          and by the third parties mentioned above.
        </p>

        <h2>Complaints</h2>
        <p>
          If you wish to make a complaint about our handling of your personal
          information, you may contact us using the details set out in this
          Privacy Policy with your full name and contact details and a detailed
          description of your complaint. We will use reasonable efforts to
          respond to you as soon as possible to acknowledge your complaint and
          inform you of the next steps we will take in dealing with your
          complaint.
        </p>

        <h2>Further information</h2>
        <p>
          If you have any specific questions, please contact us at:
          <br />
          E-mail: ______________
          <br />
          Phone: ___________
        </p>

        <h2>Provide customised content and make recommendations</h2>
        <p> We may use information we collect to provide you with customised
        content and make recommendations that are based in part on your past
        activities regarding our Services. Please visit the settings menu on
        your device or service for information about privacy choices you may
        have available to you in connection with these services.
      </p>

      <h2>Improve them and develop new products and services</h2>
      <p>
        We may use information we collect to understand the way you use the
        Services we offer so that we can improve them and develop new
        products and services. For example, we may use this information to
        make better-informed decisions about the design of our devices and
        the selection of our and third-party content that is accessible
        through our devices and services.
      </p>
    </div>
    <Footer />
  </>
);
};

export default PrivacyPolicy;